import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { LangConstant, ImageConstant, KeyConstant, PathConstant } from "const";
import { useLogin } from "hooks";
import localforage from "localforage";

const Login = () => {
  const history = useHistory();
  const { t: getLabel } = useTranslation(LangConstant.NS_LOGIN);
  const { isLoginSuccess, login } = useLogin();

  const [form, setForm] = useState({ username: "", password: "", remember: false });
  const [validated, setValidated] = useState(false);
  const [serverLogo, setServerLogo] = useState(null);
  const [serverName, setServerName] = useState("");

  const handleLogin = event => {
    event.preventDefault();
    login(form);
  };

  const handleChangeTextFields = event => {
    const key = event.target.id;
    const value = event.target.value;
    setForm(currentTextFields => ({ ...currentTextFields, [key]: value }));
  };

  const handleCheckedRemember = event => {
    setForm(currentForm => ({ ...currentForm, remember: event.target.checked }));
  };

  useEffect(() => {
    setValidated(() => validateTextField(form));
  }, [form]);

  useEffect(() => {
    if (isLoginSuccess) {
      history.replace(PathConstant.VERIFY_SMART_OTP);
    }
  }, [isLoginSuccess]);

  // Load saved server info for display
  useEffect(() => {
    const savedName = localStorage.getItem(KeyConstant.KEY_LAST_BRANCH_NAME);
    if (savedName) setServerName(savedName);

    const savedAttachment = localStorage.getItem(KeyConstant.KEY_LAST_BRANCH_ATTACHMENT);
    if (savedAttachment) {
      localforage.getItem(KeyConstant.KEY_CACHED_BRANCH_AVATAR_BLOB + savedAttachment).then(blob => {
        if (blob) setServerLogo(URL.createObjectURL(blob));
      });
    }
  }, []);

  const logoSrc = serverLogo || ImageConstant.TriosLogo;

  return (
    <div
      className="d-flex flex-row align-items-center"
      style={{ minHeight: "100vh", backgroundColor: "var(--tblr-bg-surface-secondary)", overflow: "hidden" }}
    >
      <style>{`
        .login-form-side { width: 100%; }
        @media (min-width: 992px) { .login-form-side { width: 55%; } }
      `}</style>
      {/* Left side — Form */}
      <div
        className="d-flex flex-column align-items-center justify-content-center login-form-side"
        style={{ minHeight: "100vh", padding: "2rem", marginTop: "-3rem" }}
      >
        {/* Server Logo */}
        <div className="text-center mb-3">
          <a href="." className="navbar-brand navbar-brand-autodark">
            <img
              src={logoSrc}
              alt="Server Logo"
              style={{ width: "80px", height: "80px", objectFit: "contain", borderRadius: serverLogo ? "12px" : "0" }}
            />
          </a>
        </div>

        {/* Server Name */}
        {serverName && (
          <p className="text-center text-muted mb-4" style={{ fontSize: "16px", fontWeight: 600 }}>
            {serverName}
          </p>
        )}

        {/* Login card */}
        <div className="card card-md" style={{ width: "100%", maxWidth: "450px" }}>
          <div className="card-body">
            <h2 className="h2 text-center mb-4">{getLabel(LangConstant.TXT_LOGIN)}</h2>

            <form onSubmit={handleLogin} autoComplete="off" noValidate>
              <div className="mb-3">
                <label className="form-label" htmlFor="username">
                  {getLabel(LangConstant.L_USERNAME)}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="username"
                  placeholder={getLabel(LangConstant.P_USERNAME)}
                  onChange={handleChangeTextFields}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label" htmlFor="password">
                  {getLabel(LangConstant.L_PASSWORD)}
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder={getLabel(LangConstant.P_PASSWORD)}
                  onChange={handleChangeTextFields}
                  autoComplete="current-password"
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="remember-me"
                    onChange={handleCheckedRemember}
                  />
                  <span className="form-check-label">{getLabel(LangConstant.L_REMEMBER_ME)}</span>
                </label>
              </div>

              <div className="form-footer">
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={!validated}
                >
                  {getLabel(LangConstant.L_LOGIN_BUTTON)}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Right side — Illustration */}
      <div
        className="d-none d-lg-flex align-items-center justify-content-center"
        style={{ width: "45%", minHeight: "100vh" }}
      >
        <img
          src={ImageConstant.LoginBackgroundImage}
          alt=""
          style={{ maxWidth: "380px", maxHeight: "300px", width: "80%", height: "auto", objectFit: "contain" }}
        />
      </div>
    </div>
  );
};

export default Login;

const validateTextField = payload => payload.username && payload.password;
